import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS } from './resourceTypeJsmGlobalCustomerAccessSettings.constants.tsx';
import type { JsmCustomerAccessSettingsResponse } from './JsmCustomerAccessSettingsResponse.types.tsx';

const ONE_DAY_IN_MILLIS = 1000 * 60 * 60 * 24;

export const jsmGlobalCustomerAccessSettingsResource: RouteResource<JsmCustomerAccessSettingsResponse> =
	createResource<JsmCustomerAccessSettingsResponse>({
		type: RESOURCE_TYPE_JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS,
		getKey: () => 'settings',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-jsm-customer-access-settings", jiraSpaEntry: "async-resource-jsm-customer-access-settings" */ './GetDataGetDataWithErrorLogging.tsx'
			),
		maxAge: ONE_DAY_IN_MILLIS,
	});
